import React from 'react';
import classnames from 'classnames';

import styles from './CircleLoader.module.scss';

type CircleLoaderType = {
  size?: 'small' | 'medium' | 'large' | string;
  customClass?: string;
  variant?: 'primary' | 'secondary' | string;
};

function CircleLoader({ size = 'large', customClass, variant = 'primary' }: CircleLoaderType) {
  const loaderClasses = classnames(styles.loader, {
    [styles[`loader_${size}`]]: size,
    [`${customClass}`]: customClass,
  });

  const svgClass = classnames(styles.circle_loader, {
    [styles[`circle_${variant}`]]: variant,
  });

  return (
    <div className={loaderClasses}>
      <svg className={svgClass} viewBox="25 25 50 50">
        <circle className={styles.loader_path} cx="50" cy="50" r="20" fill="none" strokeWidth="3" />
      </svg>
    </div>
  );
}

export default CircleLoader;
